import React, { useEffect, useRef } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from '@material-ui/core/Radio';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';
import ClearIcon from '@material-ui/icons/CloseOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import FiltersIcon from '@material-ui/icons/FilterList';
import Alert from '@material-ui/lab/Alert';

import SearchTips from './SearchTips';
import Filters from './Filters';

import { Context as PropertyContext } from '../../context/property.context';
import { Context as AuthContext } from '../../context/auth.context';
import { Typography } from '@material-ui/core';

const TableToolBar = (props) => {
	const [searchText, setSearchText] = React.useState('');
	
	
	
	const [open, setOpen] = React.useState(false);
	const [searchTipsOpen, setSearchTipsOpen] = React.useState(false);
	const anchorRef = React.useRef(null);
	const searchTipDescriptionTextRef = useRef();
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [anchorElFilter, setAnchorElFilter] = React.useState(null);
	const [filtersOpen, setFiltersOpen] = React.useState(false);

	const { state, searchTaxBills, clearResults } =
		React.useContext(PropertyContext);
	const auth = React.useContext(AuthContext);

	const searchByDefault = (auth.state.merchant.enableCoris) ? 'caseNumber' : ((auth.state.merchant.searchAccountStrict == true) ? 'account' : 'general');


	const [searchBy, setSearchBy] = React.useState(searchByDefault);
	const searchPlaceHolder = (searchBy === 'general')? "Searches Names, " + auth.state.merchant.accountLabel + ", " + auth.state.merchant.physicalAddressLabel + ", or " + auth.state.merchant.parcelLabel + "." : "Search " + auth.state.merchant.accountLabel;  

	const prevOpen = React.useRef(open);

	useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		let customSearchTipDescription = auth.state.merchant.customSearchTipDescription;
		if (customSearchTipDescription && searchTipDescriptionTextRef.current){
			searchTipDescriptionTextRef.current.innerHTML = customSearchTipDescription
		}

		prevOpen.current = open;
	}, []);

	const filterOpen = Boolean(anchorEl);
	const filtersOpened = Boolean(anchorElFilter);
	const id = filterOpen ? 'simple-popover' : undefined;
	const filterId = filtersOpened ? 'simple-popover' : undefined;
	const [timer, setTimer] = React.useState(null);

	const renderSearchIcon = () => {
		if (state.searchingTaxBills) {
			return (
				<div style={{ width: 48, textAlign: 'center' }}>
					<CircularProgress color="primary" disableShrink size={20} />
				</div>
			);
		} else {
			if (searchText !== '') {
				return (
					<IconButton
						aria-label="download-files"
						disabled={searchText === '' ? true : false}
						onClick={() => {
							clearResults();
							setSearchText('');
							localStorage.removeItem('searchText');
						}}
					>
						<ClearIcon />
					</IconButton>
				);
			}

			return null;
		}
	};

	return (
		<>

			<div className="searchToolbar" style={{ alignItems: 'end' }}>

				{auth.state.merchant.enableCoris == 1 && (
					<div className="searchTipsAlert">
						<Alert severity="info" style={{ alignItems: 'center' }}>
							<Typography variant="h6">Search Tips</Typography>
							<Typography variant="body1" style={{ fontSize: 14}}>
								Search Utah Court Coris Database, by Citation or Case Number.
						
								<br></br>
								Just type and hit enter.

								{auth.state.merchant.customSearchTipDescription && (
									<>
										<br></br>
										<span ref={searchTipDescriptionTextRef}></span>
									</>
								)}

							</Typography>
						</Alert>
					</div>
				)}

				{auth.state.merchant.enableCoris == 0 && (
					<div className="searchTipsAlert">
						<Alert severity="info" style={{ alignItems: 'center' }}>
							<Typography variant="h6">Search Tips</Typography>
							<Typography variant="body1" style={{ fontSize: 14}}>
								General: searches the following columns Names, {auth.state.merchant.accountLabel},
								<br /> 
								{auth.state.merchant.physicalAddressLabel}, or {auth.state.merchant.parcelLabel}.
								<br /> 
								{auth.state.merchant.accountLabel}: will only search that column.
								<br></br>
								Just type and hit enter.

								{auth.state.merchant.customSearchTipDescription && (
									<>
										<br></br>
										<span ref={searchTipDescriptionTextRef}></span>
									</>
								)}

							</Typography>
						</Alert>
					</div>
				)}

				<div id="records-found-row">
					{state.tempTaxBills.length > 0 && (
						<Typography
							variant="h6"
							color="primary"
							className="showbelow900"
							style={{
								width: 200,
								textAlign: 'left',
							}}
						>
							{state.tempTaxBills.length} Records Found
						</Typography>
					)}

					<Tooltip title="Search Tips">
						<IconButton
							aria-describedby={id}
							aria-label="search-tips"
							style={{ marginRight: 15 }}
							onClick={() => setSearchTipsOpen(true)}
							id="filter-button"
						>
							<HelpIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Filter Records" id="filter-button">
						<IconButton
							aria-describedby={filterId}
							aria-label="filters"
							onClick={() => setFiltersOpen(true)}
							disabled={
								state.tempTaxBills.length === 0 ? true : false
							}
							id="filter-button"
						>
							<FiltersIcon />
						</IconButton>
					</Tooltip>
				</div>



				<div className="searchContainer">


					{!auth.state.merchant.enableCoris == 1 && (
						<div className="searchTipsAlert">
							<Tooltip title="Search Tips">
								<IconButton
									aria-describedby={id}
									aria-label="search-tips"
									style={{ marginRight: 15, marginTop:56}}
									onClick={() => setSearchTipsOpen(true)}
								>
									<HelpIcon />
								</IconButton>
							</Tooltip>
						</div>
					)}

					<FormControl component="fieldset">


						<FormLabel style={{marginRight:15, textAlign:'right', fontSize:30}}component="legend">Search By </FormLabel>
						

						<RadioGroup
							row
							style={{display:'flex', justifyContent:'flex-end'}}
							aria-label="Search By:"
							defaultValue={searchBy}
							name="radio-buttons-group"
							onChange={(e)=> setSearchBy(e.target.value)}>
							{auth.state.merchant.enableCoris == 1 && (<FormControlLabel value="caseNumber" control={<Radio />} label="Case/Citation Number"/>)}
							{auth.state.merchant.enableCoris == 0 && (<FormControlLabel value="general" control={<Radio />} label="General"/>)}
							{auth.state.merchant.enableCoris == 0 && (<FormControlLabel value="account" control={<Radio />} label={auth.state.merchant.accountLabel} />)}

						</RadioGroup>




						<TextField
							id="search-invoices"
							label="Search"
							type="text"
							autoFocus
							placeholder={searchPlaceHolder}
							className="searchField"
							variant="outlined"
							value={searchText}
							onChange={(e) => {
								//filterList({ text: e.target.value, list: state.taxBills })
								setSearchText(e.target.value);

								// if(searchBy === 'account'){
								// 	console.log('i was called brad');
								// 	clearTimeout(timer);
								// 	setTimer(setTimeout(searchTaxBills(searchText, searchBy), 500));
								// }
						
							}}
							onKeyPress={(event) => {
								if (event.key === 'Enter') {
									searchTaxBills(searchText, searchBy);
								}
							}}
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										{renderSearchIcon()}

										<Tooltip
											title={searchPlaceHolder}
										>
											<span>
												<Button
													aria-label="download-files"
													variant="contained"
													color="primary"
													disabled={
														searchText === ''
															? true
															: false
													}
													onClick={() =>
														searchTaxBills(searchText, searchBy)
													}
												>
													Search
												</Button>
											</span>
										</Tooltip>
									</InputAdornment>
								),
							}}
						/>
					</FormControl>
				</div>
			</div>
			<SearchTips
				modalOpen={searchTipsOpen}
				setModalOpen={setSearchTipsOpen}
			/>
			{state.tempTaxBills.length > 0 && (
				<Typography
					variant="h6"
					color="primary"
					className="hideBelow900"
					style={{
						textAlign: 'right',
						marginBottom: -28,
						marginTop:20,
						paddingRight:5
					}}
				>
					{state.tempTaxBills.length} Records Found
				</Typography>
			)}
			{auth.state.merchant.visibleFilters.length > 0 && (
				<Filters
					modalOpen={filtersOpen}
					setModalOpen={setFiltersOpen}
					isMobile={true}
				/>
			)}
		</>
	);
};

export default TableToolBar;
